import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import PageHero from '../../components/feature/PageHero';
import { useScrollAnimation, useStaggerAnimation } from '../../hooks/useScrollAnimation';
import SEOHead from '../../components/feature/SEOHead';

const depoimentos = [
  {
    id: 1,
    nome: 'Carlos Eduardo Mendes',
    cargo: 'CEO',
    empresa: 'Mendes Transportes Ltda',
    localizacao: 'Vitória da Conquista/BA',
    tipo: 'Pessoa Jurídica',
    categoria: 'Seguro Automóvel',
    foto: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20male%20CEO%20transportation%20company%20confident%20warm%20smile%20portrait%20clean%20studio%20background%20corporate%20headshot%20natural%20lighting%20distinguished%20executive&width=400&height=400&seq=ibxdep-001&orientation=squarish',
    depoimento: 'Antes de conhecer a IBX Brasil, renovava meus seguros sem questionar nada. Achava que era assim mesmo: você paga o que a seguradora cobra e pronto. Depois da análise deles, percebi que estava pagando por coberturas que não precisava e, pior, sem proteção em áreas críticas para o meu negócio. A equipe fez um trabalho minucioso, explicou cada ponto da apólice e negociou condições que eu jamais conseguiria sozinho.',
    resultado: 'Economia de 42%',
    valorEconomizado: 'R$ 87.000/ano',
    destaque: true,
    rating: 5,
    data: 'Março de 2024',
    icone: 'ri-car-line',
  },
  {
    id: 2,
    nome: 'Fernanda Leal',
    cargo: 'Diretora Financeira',
    empresa: 'Construtora Leal & Associados',
    localizacao: 'Salvador/BA',
    tipo: 'Pessoa Jurídica',
    categoria: 'Gestão de Contratos',
    foto: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20businesswoman%20financial%20director%20confident%20elegant%20smile%20portrait%20clean%20studio%20background%20corporate%20headshot%20natural%20lighting%20sophisticated%20executive&width=400&height=400&seq=ibxdep-002&orientation=squarish',
    depoimento: 'A gestão dos nossos contratos de seguros era um caos. Tínhamos apólices contratadas em momentos diferentes, com seguradoras diferentes, vencimentos desencontrados e nenhum controle real. A IBX Brasil organizou tudo, renegociou com as seguradoras e hoje temos controle claro de coberturas, vencimentos e custos. A tranquilidade que isso trouxe para a diretoria não tem preço.',
    resultado: 'Organização total + 35% de economia',
    valorEconomizado: 'R$ 62.000/ano',
    destaque: true,
    rating: 5,
    data: 'Janeiro de 2024',
    icone: 'ri-file-list-3-line',
  },
  {
    id: 3,
    nome: 'Carlos Eduardo Silva',
    cargo: 'Diretor Executivo',
    empresa: 'Indústria de Alimentos Silva',
    localizacao: 'Feira de Santana/BA',
    tipo: 'Pessoa Jurídica',
    categoria: 'Recuperação de Sinistros',
    foto: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20male%20executive%20director%20food%20industry%20confident%20serious%20portrait%20clean%20studio%20background%20corporate%20headshot%20natural%20lighting%20authoritative&width=400&height=400&seq=ibxdep-003&orientation=squarish',
    depoimento: 'Tivemos um sinistro de R$ 340 mil negado pela seguradora sob alegação de falta de manutenção preventiva. Estávamos prestes a arcar com o prejuízo integral quando contratamos a IBX Brasil. A equipe analisou toda a documentação, identificou cláusulas contratuais favoráveis e conduziu a negociação de forma técnica e assertiva. Em 32 dias, o sinistro foi integralmente aprovado. Sem o trabalho deles, teríamos perdido tudo.',
    resultado: 'Sinistro recuperado integralmente',
    valorEconomizado: 'R$ 340.000 recuperados',
    destaque: true,
    rating: 5,
    data: 'Dezembro de 2023',
    icone: 'ri-shield-check-line',
  },
  {
    id: 4,
    nome: 'Marcelo Andrade',
    cargo: 'Médico e Investidor',
    empresa: 'Profissional Liberal',
    localizacao: 'Bahia',
    tipo: 'Pessoa Física',
    categoria: 'Vida Empresarial',
    foto: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20doctor%20investor%20man%20confident%20warm%20smile%20portrait%20clean%20studio%20background%20corporate%20headshot%20natural%20lighting%20distinguished%20professional&width=400&height=400&seq=ibxdep-004&orientation=squarish',
    depoimento: 'Como médico e investidor, sei a importância de proteger o patrimônio, mas não tinha tempo nem conhecimento técnico para analisar as apólices adequadamente. A análise de riscos foi muito detalhada e a negociação com as seguradoras resultou em condições que eu jamais conseguiria sozinho. O atendimento foi impecável, sempre disponível para esclarecer dúvidas.',
    resultado: 'Proteção adequada + 28% de economia',
    valorEconomizado: 'R$ 19.200/ano',
    destaque: false,
    rating: 5,
    data: 'Fevereiro de 2024',
    icone: 'ri-heart-pulse-line',
  },
  {
    id: 5,
    nome: 'Juliana Costa',
    cargo: 'Proprietária',
    empresa: 'Rede Farma Costa',
    localizacao: 'Feira de Santana/BA',
    tipo: 'Pessoa Jurídica',
    categoria: 'Consultoria Técnica',
    foto: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20businesswoman%20pharmacy%20owner%20confident%20warm%20smile%20portrait%20clean%20studio%20background%20corporate%20headshot%20natural%20lighting%20successful%20entrepreneur&width=400&height=400&seq=ibxdep-005&orientation=squarish',
    depoimento: 'Estava planejando a expansão da minha rede de farmácias e não sabia como estruturar os seguros das novas unidades. A IBX Brasil fez uma análise de riscos completa de cada localização, dimensionou as coberturas necessárias e negociou apólices específicas para a expansão. Consegui abrir as três novas lojas com total tranquilidade, sabendo que estava protegida desde o primeiro dia.',
    resultado: 'Expansão protegida + 31% de economia',
    valorEconomizado: 'R$ 44.000/ano',
    destaque: false,
    rating: 5,
    data: 'Abril de 2024',
    icone: 'ri-store-2-line',
  },
  {
    id: 6,
    nome: 'Patrícia Oliveira',
    cargo: 'Sócia-Diretora',
    empresa: 'Clínica Médica Oliveira',
    localizacao: 'Vitória da Conquista/BA',
    tipo: 'Pessoa Jurídica',
    categoria: 'Vida Empresarial',
    foto: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20female%20doctor%20clinic%20director%20confident%20warm%20smile%20portrait%20clean%20studio%20background%20corporate%20headshot%20natural%20lighting%20professional%20elegant&width=400&height=400&seq=ibxdep-006&orientation=squarish',
    depoimento: 'Nossa clínica tem 4 sócios e não tínhamos nenhuma proteção financeira estruturada em caso de falecimento de algum de nós. A IBX Brasil nos alertou sobre os riscos e estruturou um seguro de vida empresarial com cobertura proporcional à participação de cada sócio. Além de garantir a continuidade da clínica, conseguimos uma economia de 28% em relação à primeira cotação.',
    resultado: 'Proteção societária completa',
    valorEconomizado: 'R$ 2,4 milhões protegidos',
    destaque: false,
    rating: 5,
    data: 'Novembro de 2023',
    icone: 'ri-hospital-line',
  },
  {
    id: 7,
    nome: 'Roberto Almeida',
    cargo: 'Empresário',
    empresa: 'Grupo Almeida Holding',
    localizacao: 'Salvador/BA',
    tipo: 'Pessoa Jurídica',
    categoria: 'Suporte e Acompanhamento',
    foto: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20senior%20businessman%20holding%20company%20confident%20distinguished%20portrait%20clean%20studio%20background%20corporate%20headshot%20warm%20lighting%20successful%20executive&width=400&height=400&seq=ibxdep-007&orientation=squarish',
    depoimento: 'Meu grupo empresarial tem 5 empresas em setores diferentes e cada uma contratava seguros de forma isolada. Era impossível ter controle real dos custos e das coberturas. A IBX Brasil implementou uma gestão centralizada de todos os contratos, renegociou em bloco com as seguradoras e criou uma rotina de revisão trimestral. A economia consolidada foi de R$ 127 mil por ano.',
    resultado: 'Gestão unificada de 5 empresas',
    valorEconomizado: 'R$ 127.000/ano',
    destaque: false,
    rating: 5,
    data: 'Outubro de 2023',
    icone: 'ri-building-4-line',
  },
  {
    id: 8,
    nome: 'Ana Paula Santos',
    cargo: 'Advogada',
    empresa: 'Profissional Liberal',
    localizacao: 'Vitória da Conquista/BA',
    tipo: 'Pessoa Física',
    categoria: 'Seguro Automóvel',
    foto: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20female%20lawyer%20confident%20elegant%20smile%20portrait%20clean%20studio%20background%20corporate%20headshot%20natural%20lighting%20sophisticated%20attorney&width=400&height=400&seq=ibxdep-008&orientation=squarish',
    depoimento: 'Como advogada, sempre fui cuidadosa com contratos, mas nunca tinha analisado minha apólice de seguro com atenção. A IBX Brasil fez uma análise completa e identificou coberturas desnecessárias e outras que faltavam. Renegociaram com a seguradora e conseguiram reduzir meu prêmio em 25% mantendo proteção adequada. O atendimento foi excepcional, sempre claro e transparente.',
    resultado: '25% de economia + coberturas ajustadas',
    valorEconomizado: 'R$ 4.800/ano',
    destaque: false,
    rating: 5,
    data: 'Maio de 2024',
    icone: 'ri-car-line',
  },
  {
    id: 9,
    nome: 'Thiago Barbosa',
    cargo: 'Engenheiro Civil',
    empresa: 'Profissional Liberal',
    localizacao: 'Bahia',
    tipo: 'Pessoa Física',
    categoria: 'Consultoria Técnica',
    foto: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20civil%20engineer%20man%20confident%20technical%20portrait%20clean%20studio%20background%20corporate%20headshot%20natural%20lighting%20competent%20professional&width=400&height=400&seq=ibxdep-009&orientation=squarish',
    depoimento: 'Precisava de um seguro de responsabilidade civil profissional e não sabia por onde começar. A IBX Brasil fez uma análise detalhada dos riscos da minha atividade, explicou cada cobertura necessária e negociou com várias seguradoras até encontrar a melhor condição. Fiquei impressionado com o nível de conhecimento técnico da equipe sobre o mercado de seguros.',
    resultado: 'Melhor custo-benefício do mercado',
    valorEconomizado: 'R$ 7.200/ano',
    destaque: false,
    rating: 5,
    data: 'Março de 2024',
    icone: 'ri-tools-line',
  },
];

const stats = [
  { valor: '98%', label: 'de satisfação dos clientes', icone: 'ri-emotion-happy-line' },
  { valor: '+R$ 2,1M', label: 'economizados para clientes', icone: 'ri-money-dollar-circle-line' },
  { valor: '340+', label: 'clientes atendidos', icone: 'ri-group-line' },
  { valor: '25 anos', label: 'de experiência no mercado', icone: 'ri-award-line' },
];

const categorias = ['Todos', 'Seguro Automóvel', 'Vida Empresarial', 'Gestão de Contratos', 'Recuperação de Sinistros', 'Consultoria Técnica', 'Suporte e Acompanhamento'];
const tipos = ['Todos', 'Pessoa Física', 'Pessoa Jurídica'];

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex gap-0.5">
      {[...Array(5)].map((_, i) => (
        <div key={i} className="w-4 h-4 flex items-center justify-center">
          <i className={`ri-star-fill text-sm ${i < rating ? 'text-action-orange-500' : 'text-petrol-200'}`}></i>
        </div>
      ))}
    </div>
  );
}

function DestaqueCard({ dep, index, visible }: { dep: typeof depoimentos[0]; index: number; visible: boolean }) {
  return (
    <div
      className={`relative bg-white rounded-2xl overflow-hidden shadow-xl border border-petrol-100 transition-all duration-700 ease-out ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}
      style={{ transitionDelay: `${index * 150}ms` }}
    >
      {/* Faixa topo */}
      <div className="h-2 bg-gradient-to-r from-petrol-500 to-petrol-700"></div>

      <div className="p-8">
        {/* Badge destaque */}
        <div className="inline-flex items-center gap-1.5 bg-action-orange-50 text-action-orange-600 text-xs font-bold px-3 py-1.5 rounded-full mb-5 uppercase tracking-wide">
          <i className="ri-medal-line text-sm"></i>
          Caso em Destaque
        </div>

        {/* Aspas decorativas */}
        <div className="text-petrol-100 mb-3">
          <i className="ri-double-quotes-l text-5xl leading-none"></i>
        </div>

        <p className="text-petrol-800 text-base leading-relaxed mb-6 italic">
          "{dep.depoimento}"
        </p>

        {/* Resultado */}
        <div className="bg-gradient-to-r from-petrol-50 to-strategic-green-50 rounded-xl p-4 mb-6 border border-petrol-100">
          <p className="text-xs text-petrol-500 font-semibold uppercase tracking-wide mb-1">Resultado Obtido</p>
          <p className="text-petrol-900 font-bold text-base">{dep.resultado}</p>
          <p className="text-strategic-green-600 font-bold text-lg mt-0.5">{dep.valorEconomizado}</p>
        </div>

        {/* Autor */}
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-3 ring-petrol-100 shadow-md bg-petrol-100">
            <img
              src={dep.foto}
              alt={dep.nome}
              className="w-full h-full object-cover object-top"
              loading="lazy"
              decoding="async"
              width="56"
              height="56"
            />
          </div>
          <div className="flex-1">
            <p className="font-bold text-petrol-900 text-sm">{dep.nome}</p>
            <p className="text-petrol-600 text-xs">{dep.cargo} — {dep.empresa}</p>
            <p className="text-petrol-400 text-xs mt-0.5">{dep.localizacao} · {dep.data}</p>
          </div>
          <StarRating rating={dep.rating} />
        </div>
      </div>
    </div>
  );
}

function DepoimentoCard({ dep, index, visible }: { dep: typeof depoimentos[0]; index: number; visible: boolean }) {
  const [expandido, setExpandido] = useState(false);
  const textoLongo = dep.depoimento.length > 200;
  const textoExibido = textoLongo && !expandido ? dep.depoimento.slice(0, 200) + '...' : dep.depoimento;

  return (
    <div
      className={`bg-white rounded-xl border border-petrol-100 shadow-md hover:shadow-xl transition-all duration-700 ease-out overflow-hidden ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="p-6">
        {/* Header */}
        <div className="flex items-start gap-4 mb-4">
          <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-petrol-100 bg-petrol-100">
            <img
              src={dep.foto}
              alt={dep.nome}
              className="w-full h-full object-cover object-top"
              loading="lazy"
              decoding="async"
              width="48"
              height="48"
            />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-bold text-petrol-900 text-sm truncate">{dep.nome}</p>
            <p className="text-petrol-600 text-xs">{dep.cargo}</p>
            <p className="text-petrol-400 text-xs">{dep.empresa}</p>
          </div>
          <div className="w-9 h-9 rounded-lg bg-petrol-50 flex items-center justify-center flex-shrink-0">
            <i className={`${dep.icone} text-petrol-500 text-base`}></i>
          </div>
        </div>

        {/* Tags */}
        <div className="flex flex-wrap gap-2 mb-4">
          <span className="px-2.5 py-1 bg-petrol-50 text-petrol-700 text-xs font-semibold rounded-full">{dep.tipo}</span>
          <span className="px-2.5 py-1 bg-action-orange-50 text-action-orange-600 text-xs font-semibold rounded-full">{dep.categoria}</span>
        </div>

        <StarRating rating={dep.rating} />

        {/* Texto */}
        <p className="text-petrol-700 text-sm leading-relaxed mt-3 italic">
          "{textoExibido}"
        </p>
        {textoLongo && (
          <button
            onClick={() => setExpandido(!expandido)}
            className="text-petrol-500 text-xs font-semibold mt-1 hover:text-action-orange-500 transition-colors cursor-pointer"
          >
            {expandido ? 'Ver menos' : 'Ler mais'}
          </button>
        )}

        {/* Resultado */}
        <div className="mt-4 pt-4 border-t border-petrol-50 flex items-center justify-between">
          <div>
            <p className="text-xs text-petrol-400 mb-0.5">Resultado</p>
            <p className="text-strategic-green-600 font-bold text-sm">{dep.valorEconomizado}</p>
          </div>
          <p className="text-xs text-petrol-400">{dep.data}</p>
        </div>
      </div>
    </div>
  );
}

export default function DepoimentosPage() {
  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Depoimentos de Clientes - Consultoria em Seguros",
    "description": "Veja o que nossos clientes dizem sobre nossa consultoria especializada em seguros empresariais e gestão de riscos corporativos.",
    "url": "https://ibxbrasil.com.br/depoimentos"
  };

  const [filtroCategoria, setFiltroCategoria] = useState('Todos');
  const [filtroTipo, setFiltroTipo] = useState('Todos');

  const { ref: statsRef, visibleItems: statsVisible } = useStaggerAnimation(stats.length);
  const { ref: destaqueRef, visibleItems: destaqueVisible } = useStaggerAnimation(3);
  const { ref: gridRef, visibleItems: gridVisible } = useStaggerAnimation(depoimentos.filter(d => !d.destaque).length);
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation();

  const destaques = depoimentos.filter(d => d.destaque);
  const demais = depoimentos.filter(d => !d.destaque).filter(dep => {
    const matchCategoria = filtroCategoria === 'Todos' || dep.categoria === filtroCategoria;
    const matchTipo = filtroTipo === 'Todos' || dep.tipo === filtroTipo;
    return matchCategoria && matchTipo;
  });

  return (
    <>
      <SEOHead
        title="Depoimentos de Clientes - Consultoria em Seguros | IBX Brasil"
        description="Leia depoimentos reais de empresas que transformaram sua gestão de seguros com nossa consultoria especializada. Avaliações e casos de sucesso."
        canonical="https://ibxbrasil.com.br/depoimentos"
        ogImage="https://readdy.ai/api/search-image?query=satisfied%20business%20clients%20giving%20testimonials%20about%20insurance%20consulting%20services%20with%20five%20star%20ratings%20and%20positive%20feedback&width=1200&height=630&seq=ibx-depoimentos-og&orientation=landscape"
        schema={webPageSchema}
      />
      <div className="min-h-screen bg-white">
        <Navbar />

        {/* HERO */}
        <PageHero
          badge="DEPOIMENTOS REAIS"
          title="Histórias de Quem Confiou na IBX Brasil"
          titleHighlight="Confiou"
          titleHighlightColor="orange"
          subtitle="Mais de 340 clientes transformaram sua gestão de seguros com a IBX Brasil. Veja os resultados reais em economia, proteção e tranquilidade."
          backgroundImage="https://readdy.ai/api/search-image?query=professional%20business%20meeting%20insurance%20consulting%20office%20modern%20interior%20deep%20teal%20petrol%20color%20scheme%20elegant%20corporate%20environment%20warm%20lighting%20sophisticated%20atmosphere%20happy%20satisfied%20clients%20testimonials&width=1440&height=700&seq=dep-hero-bg&orientation=landscape"
          overlayIntensity="medium"
          primaryCta={{
            text: 'Quero Ser o Próximo Caso',
            href: 'https://wa.me/5577988080505?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20uma%20an%C3%A1lise%20gratuita.',
            icon: 'ri-whatsapp-line'
          }}
          secondaryCta={{
            text: 'Ver Casos de Sucesso',
            href: '/casos-de-sucesso',
            icon: 'ri-bar-chart-line'
          }}
        />

        {/* ESTATÍSTICAS */}
        <section className="bg-gradient-to-r from-petrol-900 to-petrol-800 py-12 sm:py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div
              ref={statsRef as React.RefObject<HTMLDivElement>}
              className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8"
            >
              {stats.map((stat, i) => (
                <div
                  key={i}
                  className={`text-center transition-all duration-700 ease-out ${statsVisible[i] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                  style={{ transitionDelay: `${i * 120}ms` }}
                >
                  <div className="w-12 h-12 bg-action-orange-500/20 rounded-xl flex items-center justify-center mx-auto mb-3">
                    <i className={`${stat.icone} text-action-orange-400 text-2xl`}></i>
                  </div>
                  <p className="text-3xl sm:text-4xl font-bold text-white mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {stat.valor}
                  </p>
                  <p className="text-petrol-300 text-xs sm:text-sm">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* DEPOIMENTOS EM DESTAQUE */}
        <section className="py-16 sm:py-24 bg-gradient-to-b from-petrol-50 to-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 bg-action-orange-100 text-action-orange-600 text-xs font-bold px-4 py-2 rounded-full mb-4 uppercase tracking-widest">
                <i className="ri-medal-line"></i>
                Casos em Destaque
              </div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-petrol-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Resultados que <span className="text-strategic-green-500">Falam por Si</span>
              </h2>
              <p className="text-petrol-600 text-base sm:text-lg max-w-2xl mx-auto">
                Três histórias que mostram o impacto real da gestão profissional de seguros com a IBX Brasil.
              </p>
            </div>

            <div
              ref={destaqueRef as React.RefObject<HTMLDivElement>}
              className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8"
            >
              {destaques.map((dep, i) => (
                <DestaqueCard key={dep.id} dep={dep} index={i} visible={destaqueVisible[i]} />
              ))}
            </div>
          </div>
        </section>

        {/* TODOS OS DEPOIMENTOS */}
        <section className="py-16 sm:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

            {/* Título */}
            <div className="text-center mb-10">
              <h2 className="text-3xl sm:text-4xl font-bold text-petrol-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                Mais Depoimentos de <span className="text-petrol-500">Clientes</span>
              </h2>
              <p className="text-petrol-600 text-base max-w-xl mx-auto">
                Filtre por tipo de cliente ou serviço para encontrar histórias semelhantes à sua.
              </p>
            </div>

            {/* Filtros */}
            <div className="bg-petrol-50 rounded-2xl p-5 sm:p-6 mb-10 space-y-4">
              <div>
                <p className="text-xs font-bold text-petrol-600 uppercase tracking-wide mb-3">Tipo de Cliente</p>
                <div className="flex flex-wrap gap-2">
                  {tipos.map(tipo => (
                    <button
                      key={tipo}
                      onClick={() => setFiltroTipo(tipo)}
                      className={`px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                        filtroTipo === tipo
                          ? 'bg-petrol-700 text-white shadow-md'
                          : 'bg-white text-petrol-700 border border-petrol-200 hover:border-petrol-400'
                      }`}
                    >
                      {tipo}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <p className="text-xs font-bold text-petrol-600 uppercase tracking-wide mb-3">Tipo de Serviço</p>
                <div className="flex flex-wrap gap-2">
                  {categorias.map(cat => (
                    <button
                      key={cat}
                      onClick={() => setFiltroCategoria(cat)}
                      className={`px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                        filtroCategoria === cat
                          ? 'bg-action-orange-500 text-white shadow-md'
                          : 'bg-white text-petrol-700 border border-petrol-200 hover:border-action-orange-300'
                      }`}
                    >
                      {cat}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Grid de depoimentos */}
            {demais.length > 0 ? (
              <div
                ref={gridRef as React.RefObject<HTMLDivElement>}
                className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
              >
                {demais.map((dep, i) => (
                  <DepoimentoCard key={dep.id} dep={dep} index={i} visible={gridVisible[i]} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-16 h-16 bg-petrol-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-search-line text-petrol-400 text-2xl"></i>
                </div>
                <p className="text-petrol-600 font-semibold text-lg mb-2">Nenhum depoimento encontrado</p>
                <p className="text-petrol-400 text-sm">Tente outros filtros para ver mais resultados.</p>
              </div>
            )}
          </div>
        </section>

        {/* CTA WHATSAPP DEDICADO */}
        <section className="py-16 sm:py-20 bg-gradient-to-br from-strategic-green-600 to-strategic-green-800 relative overflow-hidden">
          {/* Elementos decorativos */}
          <div className="absolute top-0 left-0 w-72 h-72 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full translate-x-1/3 translate-y-1/3"></div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full opacity-5">
            <i className="ri-whatsapp-line text-white" style={{ fontSize: '600px', lineHeight: 1 }}></i>
          </div>

          <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

              {/* Lado esquerdo — texto */}
              <div className="flex-1 text-center lg:text-left">
                <div className="inline-flex items-center gap-2 bg-white/15 border border-white/25 text-white text-xs font-bold px-4 py-2 rounded-full mb-5 uppercase tracking-widest">
                  <i className="ri-whatsapp-line text-sm"></i>
                  Atendimento Imediato
                </div>

                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Fale Agora com um{' '}
                  <span className="text-white underline decoration-white/40 decoration-wavy underline-offset-4">
                    Especialista
                  </span>
                </h2>

                <p className="text-strategic-green-100 text-base sm:text-lg leading-relaxed mb-6 max-w-lg">
                  Nossa equipe está pronta para analisar sua situação e apresentar uma proposta personalizada. Resposta garantida em até 2 horas.
                </p>

                {/* Benefícios rápidos */}
                <ul className="space-y-2.5 mb-8">
                  {[
                    'Análise gratuita da sua apólice atual',
                    'Identificação de coberturas desnecessárias',
                    'Proposta com economia real em até 24h',
                    'Sem burocracia, sem compromisso',
                  ].map((item, i) => (
                    <li key={i} className="flex items-center gap-3 text-white text-sm font-medium">
                      <div className="w-5 h-5 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                        <i className="ri-check-line text-xs text-white"></i>
                      </div>
                      {item}
                    </li>
                  ))}
                </ul>

                {/* Número em destaque */}
                <a
                  href="https://wa.me/5577988080505"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-2 text-white/80 hover:text-white text-sm font-semibold transition-colors cursor-pointer"
                >
                  <i className="ri-phone-line"></i>
                  (77) 98808-0505
                </a>
              </div>

              {/* Lado direito — card de ação */}
              <div className="w-full lg:w-auto lg:min-w-[340px]">
                <div className="bg-white rounded-2xl p-8 shadow-2xl text-center">
                  {/* Ícone WhatsApp animado */}
                  <div className="relative w-20 h-20 mx-auto mb-5">
                    <div className="absolute inset-0 bg-strategic-green-100 rounded-full animate-ping opacity-40"></div>
                    <div className="relative w-20 h-20 bg-strategic-green-500 rounded-full flex items-center justify-center shadow-lg">
                      <i className="ri-whatsapp-line text-white text-4xl"></i>
                    </div>
                  </div>

                  <h3 className="text-petrol-900 font-bold text-xl mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                    Iniciar Conversa
                  </h3>
                  <p className="text-petrol-500 text-sm mb-6 leading-relaxed">
                    Clique abaixo e fale diretamente com um consultor da IBX Brasil agora mesmo.
                  </p>

                  <a
                    href="https://wa.me/5577988080505?text=Ol%C3%A1%2C%20vi%20os%20depoimentos%20no%20site%20e%20gostaria%20de%20solicitar%20uma%20an%C3%A1lise%20gratuita%20dos%20meus%20seguros."
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="w-full flex items-center justify-center gap-3 bg-strategic-green-500 hover:bg-strategic-green-600 text-white px-6 py-4 rounded-xl font-bold text-base transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer mb-4"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    Falar no WhatsApp
                  </a>

                  <p className="text-petrol-400 text-xs">
                    🔒 Seus dados são tratados com total sigilo
                  </p>

                  {/* Avaliação */}
                  <div className="mt-5 pt-5 border-t border-petrol-100 flex items-center justify-center gap-1.5">
                    {[...Array(5)].map((_, i) => (
                      <div key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-action-orange-400 text-sm"></i>
                      </div>
                    ))}
                    <span className="text-petrol-500 text-xs ml-1.5 font-semibold">98% de satisfação</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* BANNER CONFIANÇA */}
        <section className="py-14 bg-petrol-50 border-y border-petrol-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
              {[
                { icone: 'ri-verified-badge-line', titulo: 'Análise 100% Gratuita', desc: 'Sem compromisso. Avaliamos sua situação atual sem custo.' },
                { icone: 'ri-lock-line', titulo: 'Sigilo Garantido', desc: 'Suas informações são tratadas com total confidencialidade.' },
                { icone: 'ri-customer-service-2-line', titulo: 'Suporte Dedicado', desc: 'Atendimento personalizado durante todo o processo.' },
              ].map((item, i) => (
                <div key={i} className="flex flex-col items-center gap-3">
                  <div className="w-12 h-12 bg-petrol-100 rounded-xl flex items-center justify-center">
                    <i className={`${item.icone} text-petrol-600 text-2xl`}></i>
                  </div>
                  <p className="font-bold text-petrol-900 text-base">{item.titulo}</p>
                  <p className="text-petrol-600 text-sm leading-relaxed max-w-xs">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA FINAL */}
        <section
          ref={ctaRef as React.RefObject<HTMLElement>}
          className={`py-20 sm:py-28 relative overflow-hidden transition-all duration-1000 ease-out ${ctaVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-petrol-900 via-petrol-800 to-petrol-700"></div>
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20geometric%20pattern%20professional%20insurance%20business%20deep%20teal%20dark%20background%20elegant%20minimal%20texture&width=1440&height=600&seq=dep-cta-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="inline-flex items-center gap-2 bg-action-orange-500/20 border border-action-orange-400/30 text-action-orange-300 text-xs font-bold px-4 py-2 rounded-full mb-6 uppercase tracking-widest">
              <i className="ri-rocket-line"></i>
              Comece Agora
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Você Pode Ser o{' '}
              <span className="text-action-orange-400">Próximo Caso</span>{' '}
              de Sucesso
            </h2>

            <p className="text-petrol-200 text-base sm:text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
              Solicite uma análise gratuita e descubra quanto você pode economizar com gestão profissional de seguros. Sem compromisso, sem custo.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://wa.me/5577988080505?text=Ol%C3%A1%2C%20vi%20os%20depoimentos%20e%20gostaria%20de%20solicitar%20uma%20an%C3%A1lise%20gratuita."
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center justify-center gap-2.5 bg-action-orange-500 hover:bg-action-orange-600 text-white px-8 py-4 rounded-xl font-bold text-base transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                Solicitar Análise Gratuita
              </a>
              <Link
                to="/contato"
                className="inline-flex items-center justify-center gap-2.5 bg-white/10 hover:bg-white/20 border border-white/30 text-white px-8 py-4 rounded-xl font-bold text-base transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line text-xl"></i>
                Enviar Mensagem
              </Link>
            </div>

            {/* Micro-prova social */}
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-petrol-300 text-sm">
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-strategic-green-400"></i>
                Análise gratuita e sem compromisso
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-strategic-green-400"></i>
                Resposta em até 24 horas
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-strategic-green-400"></i>
                +340 clientes satisfeitos
              </div>
            </div>
          </div>
        </section>

        <Footer />

        {/* WhatsApp Fixo */}
        <a
          href="https://wa.me/5577988080505?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20a%20IBX%20Brasil."
          target="_blank"
          rel="nofollow noreferrer"
          className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-strategic-green-500 hover:bg-strategic-green-600 text-white rounded-full shadow-2xl flex items-center justify-center transition-all hover:scale-110 cursor-pointer"
          aria-label="WhatsApp IBX Brasil"
        >
          <div className="absolute inset-0 rounded-full bg-strategic-green-500 animate-ping opacity-30"></div>
          <i className="ri-whatsapp-line text-2xl relative z-10"></i>
        </a>
      </div>
    </>
  );
}
